<template>
  <div class="content">
    <h2 class="page-title">サイト利用規約</h2>
    <section id="kiyaku" class="pl-2 pr-3 px-md-5">
      <ol class="pl-4">
        <li class="main">目的</li>
        <div>
          株式会社ロジコ(以下｢当社｣といいます。)が提供する当社お客様向け陸送関連サービス(以下｢当サービス｣といいます。)をご利用される場合には、本規約の内容に同意いただいたものといたします。
        </div>
        <li class="main">個人情報について</li>
        <div>
          当サービスで収集させていただく個人情報は、当社の個人情報保護方針に従って取り扱うものとします。
        </div>
        <li class="main">サービスのご利用について</li>
        <ul class="list-unstyled">
          <li>
            <div>
              1)&emsp;当サービスをご利用いただく際に必要な機器やソフトウェア、通信手段等のご用意、当サービスへの接続に係る費用については、ご利用者ご自身の責任と費用でご用意いただく必要があります。当社はご利用者のインターネットにアクセスするための準備、方法などについては一切関与いたしません。
            </div>
          </li>
          <li>
            <div>
              2)&emsp;以下の場合、当サービスの利用ができない場合があります。尚、当社は理由の如何によらず、当サービスが利用できなくなることによるすべての損害に対して一切の責任を負いません。
            </div>
          </li>
          <ul>
            <ol>
              <li>
                サーバ、システム等に故障が生じた場合及び定期・不定期のメンテナンスのために、システムの全部または一部を休止する場合
              </li>
              <li>利用者の通信機器の破損等の場合</li>
              <li>火災、停電、天災などの不可抗力により、提供が困難な場合</li>
              <li>第一種電気通信事業者の任務が提供されない場合</li>
              <li>その他やむを得ない事由のある場合</li>
            </ol>
          </ul>
          <li><div>3)&emsp;他のサービスへのリンクの扱いについて</div></li>
          <li>
            <div>
              &emsp;&emsp;当サービスにおいて、第三者が提供しているサービス等へのリンクを提供している場合があります。当社はそれらのサービスやリソースを管理しておらず、それらのサービスやリソースについては一切の責任を負いかねます。当社は、それらのソフトウェア、広告、商品、サービスなどに起因または関連して生じた一切の損害（間接的、直接的であるとに関わらず）を賠償する責任を負いません。
            </div>
          </li>
          <li><div>4)&emsp;当サービスへのリンクについて</div></li>
          <li>
            <div>
              &emsp;&emsp;当サービスのトップページへのリンクは、個人、団体または、営利、非営利を問わず連絡の必要はございません。
            </div>
          </li>
          <li>
            <div>
              &emsp;&emsp;ただし以下の項目に該当する場合はリンクをお断りしております。
            </div>
          </li>
          <ul>
            <ol>
              <li>
                アダルトコンテンツ、または公序良俗に反する内容を含んだウェブサイト
              </li>
              <li>
                違法、または違法行為に結びつく可能性を有する内容を含んだウェブサイト
              </li>
              <li>当社または第三者に不利益を与えているウェブサイト</li>
              <li>当社または第三者を誹謗中傷しているウェブサイト</li>
              <li>
                当社の許諾なく、当社が保持する財産（ロゴマーク、キャラクターなど）を利用しているウェブサイト
              </li>
              <li>
                当社またはその関連会社と何らかの提携または協力関係にあるものと誤認を与えるおそれのあるウェブサイト
              </li>
              <li>
                当社またはその関連会社の名誉・信用を損なうおそれのあるウェブサイト
              </li>
              <li>
                コンピューターウィルス等有害なプログラムを使用もしくは提供する行為、またはそのおそれのある行為を行っている場合
              </li>
              <li>
                犯罪行為または犯罪に結びつく行為、またはそのおそれのある行為を行っている場合
              </li>
              <li>
                他人の電子メールアドレスを登録する等、虚偽の申告、届出を行う行為を行っている場合
              </li>
              <li>その他、当社が不適当と判断した場合</li>
            </ol>
          </ul>
          <li>
            <div>
              5)&emsp;出版物などに当サービスのURLを掲載する場合は当社まで事前にご連絡ください(連絡先につきましては、当社Webサイトをご覧ください)。ただし、ウェブサイト上の文書、プログラム、音声、写真、画像、映像、文字などのソフトウェアに直接リンクする行為、またはウェブサイトの一部または全部を引用する行為は禁止させていただいておりますので、あらかじめご了承ください。なお、個別のページへのリンクは、サイト構造やサーバ構成の変更にともなって予告無くリンク先が無くなる可能性があります。あらかじめご了承ください。
            </div>
          </li>
        </ul>

        <li class="main">知的財産権について</li>
        <div>
          当サービスのすべてのコンテンツ（著作物、肖像、キャラクター、その他の一切の情報）は、当社もしくは、その委託先等が著作権等の知的財産権、使用権、その他の権利を有しています。著作権法で認められている範囲を超えての使用はお控え下さい。
        </div>
        <li class="main">禁止事項</li>
        <div>
          当サービスのご利用にあたり、ご利用者は以下の行為を行わないものとします。違反した場合には、当サービスの利用を予告なくお断りさせていただく場合がありますので、あらかじめご了承下さい。
        </div>
        <ul>
          <ol>
            <li>
              当社およびその関係会社、その他あらゆる人物や組織を装ったり、またそれらと提携関係にあると偽ったりそれらを他者に誤解させるように伝える行為。
            </li>
            <li>
              特許権、実用新案権、商標権、意匠権、著作権、著作隣接権、肖像権、トレードシークレット、プライバシー、その他他者の権利、財産を侵害する行為、または侵害するおそれのある行為。
            </li>
            <li>
              当サービスで提供される情報、著作物を利用者の個人的な利用目的以外で、複製・複写・改変・転載し他者に利用させたり、ネットワークの内外を問わず公衆に再提供したり、他者の権利を侵害する行為。
            </li>
            <li>
              他者になりすまして当サービスを利用、もしくは他者になりすまして対応機器へアクセスする行為。
            </li>
            <li>機器内に記録された情報を改ざん、消去する行為。</li>
            <li>
              法律、法令、条例または公序良俗に違反、または違反するおそれのある行為。
            </li>
            <li>
              当サービスの運営を妨げるまたは妨げるおそれのあるような行為。
            </li>
            <li>前各号に定める行為を助長する行為。</li>
            <li>その他、当社が不適切と判断する行為。</li>
          </ol>
        </ul>
        <li class="main">サービスの提供の変更・停止・中断・終了について</li>
        <div>
          当サービスのすべてまたは一部を、ご利用者に事前に通告することなく変更・停止・中断・終了することができるものとします。なお、当サービスの変更・停止・中断・終了等によって生じた損害について、当社は一切の責任を負わないものとします。
        </div>
        <li class="main">免責事項</li>
        <ul class="list-unstyled">
          <li>
            <div>
              1)&emsp;当サービスは、細心の注意をはらって情報の掲載、提供を行なっていますが、当社は、完全性、正確性、有用性等、あるいは接続環境等に関してその一切を保証するものではありません。
            </div>
          </li>
          <li>
            <div>
              2)&emsp;当サービスが提供する情報、発信する内容については、一切の責任を負わないものとします。
            </div>
          </li>
          <li>
            <div>
              3)&emsp;第三者による当サービスの妨害、情報改変等によってサービスが中断・遅延・あるいは誤送信等の欠陥が生じた場合でも、当社はご利用者あるいは第三者が被った被害について責任は負わないものとします。
            </div>
          </li>
        </ul>
        <li class="main">利用規約の変更K</li>
        <div>本規約は、ご利用者への予告なく変更することがあります。</div>
        <li class="main">準拠法および管轄</li>
        <div>
          本規約の準拠法は日本法とし、本規約または当サービスに関して生じる一切の紛争については東京地方裁判所または東京簡易裁判所を第一審の専属管轄裁判所とします。
        </div>
      </ol>
    </section>
  </div>
</template>
<script>
import Mixin from './mixin/Mixin'
export default {
  name: 'Kiyaku',
  components: {},
  mixins: [Mixin],
}
</script>

<style lang="sass" scoped>
@import '../assets/css/logico2'
.main
  font-weight: 600
  margin-top: 10px
li
  div
    margin-left: 1em
  div:before
    content: ""
    margin-left: -2em
@include sp
  section
    font-size: 12px
    ul
      padding-inline-start: 10px
</style>



// WEBPACK FOOTER //
// src/components/Kiyaku.vue